export { RegulatedTrustTile, type RegulatedTrustTileProps } from './RegulatedTrustTile';
